var _title, _g, _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImportRounded = function SvgImportRounded(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 768,
    viewBox: "0 0 768 768",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M624.975 207.614h-127.502v75.661h127.502c37.931 0 67.352 19.357 67.352 36.028v335.52c0 16.658-29.42 36.040-67.352 36.040h-481.975c-37.919 0-67.339-19.382-67.339-36.040v-335.483c0-16.671 29.419-36.040 67.339-36.040h127.49v-75.662h-127.49c-80.189 0-143 49.066-143 111.701v335.495c0 62.647 62.812 111.688 143 111.688h482c80.163 0 143-49.067 143-111.688v-335.495c-0.013-62.66-62.824-111.727-143.025-111.727z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M498.469 365.746c-9.685 0-19.357 3.707-26.747 11.097l-47.364 47.351v-384.889c0-20.882-16.936-37.831-37.831-37.831s-37.831 16.948-37.831 37.831v387.437l-49.924-49.911c-7.39-7.39-17.075-11.097-26.747-11.097s-19.357 3.707-26.746 11.097c-14.779 14.754-14.779 38.714 0 53.48l112.95 112.95c7.39 7.39 17.075 11.059 26.734 11.059 0.101 0 0.202 0 0.29 0s0.189 0 0.278 0c9.685 0 19.344-3.67 26.734-11.059l112.95-112.95c14.779-14.767 14.779-38.726 0-53.48-7.39-7.377-17.049-11.084-26.747-11.084z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImportRounded, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/import-rounded.4fc2f6ee.svg";
export { ForwardRef as ReactComponent };